import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=c1852c62&scoped=true&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=c1852c62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1852c62",
  null
  
)

export default component.exports